import request from '../../../shared/request'

export function getDobAttachments(job_id) {
  return request(`/job/dob_attachments/${job_id}/`)
}

export function fetchDobFolders(job_id) {
  return request(`/job/dob_attachments/${job_id}/folders`)
}

export function createDobFolder(payload) {
  return request(`/job/dob_attachments/`, {
    method: 'POST',
    body: payload,
    headers: {
      Accept: 'application/json'
    }
  })
}

export function updateDobFolder(payload) {
  return request(`/job/dob_attachments/${payload.dobAttachmentFolderId}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteDobFolder(jobDobFolderId) {
  return request(`/job/dob_attachments/${jobDobFolderId}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// ATTACHMENTS
export function uploadDobFolderAttachments(payload) {
  return request(`/job/dob_attachments/${payload.dobAttachmentFolderId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getDobFolderAttachments(dobAttachmentFolderId) {
  return request(`/job/dob_attachments/${dobAttachmentFolderId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/dob_attachments/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteDobFolderAttachment(payload) {
  return request(
    `/job/dob_attachments/${payload.attachmentId}/attachment/?dobAttachmentFolderId=${
      payload.dobAttachmentFolderId
    }`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/redux/api/job/dobAttachments.js